export default "__VITE_ASSET__7f6bed40__"